import React, { useEffect, useState } from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Typography } from "components";

const RECOMMENDER_MESSAGE_KEYS = [
  "recommenderComputing.searchingCoverCrops",
  "recommenderComputing.findingNutrientBindingCrops",
  "recommenderComputing.selectingBestMatch",
  "recommenderComputing.searchingSoilTypeMatch",
];

const RECOMMENDER_INTERVAL_MS = 1500;

type RecommenderComputingProps = {
  onCycleComplete?: () => void;
};

export const RecommenderComputing = ({ onCycleComplete }: RecommenderComputingProps) => {
  const { t } = useTranslation("scenarioAnalysis");
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentMessageIndex + 1) % RECOMMENDER_MESSAGE_KEYS.length;
      setCurrentMessageIndex(nextIndex);
      if (nextIndex === 0) onCycleComplete?.();
    }, RECOMMENDER_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [currentMessageIndex, onCycleComplete]);

  return (
    <Flex vertical align="center" justify="center" gap="0.75rem" className="recommender-computing">
      <Icon iconName="klim/plant-ai" size="xxl" strokeWidth={0.75} />
      <Typography key={currentMessageIndex} variant="paragraph-l">
        {t(RECOMMENDER_MESSAGE_KEYS[currentMessageIndex])}
      </Typography>
    </Flex>
  );
};

export default RecommenderComputing;
